"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAppMutation = useAppMutation;
const antd_1 = require("antd");
const react_intl_1 = require("react-intl");
const react_query_1 = require("react-query");
function useAppMutation(mutationFn, options) {
    const intl = (0, react_intl_1.useIntl)();
    return (0, react_query_1.useMutation)(mutationFn, {
        ...options,
        onError: (options === null || options === void 0 ? void 0 : options.onError)
            ? options === null || options === void 0 ? void 0 : options.onError
            : error => {
                console.error(error);
                antd_1.notification.error({
                    message: intl.formatMessage({
                        id: 'general.error',
                    }),
                    description: intl.formatMessage({
                        id: 'general.something_went_wrong',
                    }),
                });
            },
    });
}
